import {createStore, applyMiddleware, compose} from 'redux';
import thunk from 'redux-thunk';
// import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import rootReducer from './reducers';


const middleware = [thunk];

//
// const initialState = {};
// const store = createStore( rootReducer, initialState
//    , compose( applyMiddleware(...middleware)
//    , window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()))
//
// export default store


 const store = createStore(rootReducer, compose(
     applyMiddleware(...middleware),
     ));
 export default store
